export enum DotCaPageSection {
  Radio = "radio",
  Television = "television",
}
